var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ykEditor"}},[_c('ckeditor',{attrs:{"id":"ckeditor","editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }